import React from 'react'
import ImportantSectionContent from '../ui/ImportantSectionContent'
import FAQSectionContent from '../ui/FAQSectionContent'

export const steamHelpSections = [
  {
    label: 'ВАЖНО',
    content: <ImportantSectionContent />,
  },
  {
    label: 'FAQ',
    content: <FAQSectionContent />,
  },
]
